import React from "react";
import "./TechnologyStack.scss";

// Components
import AnimatedText from "components/Headings/Common/Utils/Animation/AnimatedText";
import TitleL1 from "components/Titles/TitleL1/TitleL1";
import TitleL2 from "components/Titles/TitleL2/TitleL2";

// Libraries & Packages
import { useThemeStore } from "utils/state/Store";

function TechnologyStack({ technologyData }) {
  // State
  const { theme } = useThemeStore();

  // Functions
  const sortingOrder = {
    categories: ["Design", "Frontend Development", "Backend Development"],
    subCategories: {
      Design: ["Graphic Design", "Motion Design"],
      "Frontend Development": [
        "Fundamentals",
        "CSS Extensions",
        "UI/UX Design",
        "Frameworks/Libraries",
        "State Management",
      ],
      "Backend Development": [
        "Fundamentals",
        "Authentication",
        "Database",
        "Cloud Storage",
        "Analytics",
        "Web Sockets",
        "Content Management",
        "Email Services",
        "Hosting",
      ],
    },
  };

  const organizeData = (data) => {
    return data
      .reduce((acc, currentItem) => {
        const { category, subCategory, title, thumbnail } = currentItem.fields;

        const categoryIndex = sortingOrder.categories.indexOf(category);

        if (categoryIndex === -1) {
          // Category not found in the sorting order, skip this entry
          return acc;
        }

        const subCategoryIndex =
          sortingOrder.subCategories[category]?.indexOf(subCategory);

        if (subCategoryIndex === -1) {
          // Subcategory not found in the sorting order, skip this entry
          return acc;
        }

        if (!acc[categoryIndex]) {
          acc[categoryIndex] = {
            category,
            subCategories: [],
          };
        }

        if (!acc[categoryIndex].subCategories[subCategoryIndex]) {
          acc[categoryIndex].subCategories[subCategoryIndex] = {
            subCategory,
            technologies: [],
          };
        }

        acc[categoryIndex].subCategories[subCategoryIndex].technologies.push({
          title,
          thumbnail: `https:${thumbnail.fields.file.url}`,
        });

        // Sort technologies in ascending order
        acc[categoryIndex].subCategories[subCategoryIndex].technologies.sort(
          (a, b) => a.title.localeCompare(b.title)
        );

        return acc;
      }, [])
      .filter(Boolean); // Remove undefined entries in the result
  };

  return (
    <div className="technologyStack">
      {organizeData(technologyData).map((item, i) => {
        const { category, subCategories } = item;
        return (
          <div className="technologyStack__category" key={i}>
            <div className="technologyStack__category__title">
              <TitleL1>
                <AnimatedText>{category}</AnimatedText>
              </TitleL1>
            </div>
            <div className="technologyStack__category__content">
              {subCategories.map((item, i) => {
                const { subCategory, technologies } = item;
                return (
                  <div className="technologyStack__subCategories" key={i}>
                    <div className="technologyStack__subCategory__title">
                      <TitleL2>
                        <AnimatedText>{subCategory}</AnimatedText>
                      </TitleL2>
                    </div>
                    <div className="technologyStack__subCategory__content">
                      {technologies.map((item, i) => {
                        const { title, thumbnail } = item;
                        return (
                          <AnimatedText key={i}>
                            <div className="technologyStack__subCategory__content__card">
                              <div className="technologyStack__subCategory__content__card__thumbnail">
                                <img src={thumbnail} alt="" />
                              </div>
                              <div
                                className="technologyStack__subCategory__content__card__title"
                                style={{
                                  color: theme.palette.miscellaneous.grey.main,
                                }}
                              >
                                {title}
                              </div>
                            </div>
                          </AnimatedText>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default TechnologyStack;
